/* ==========================================================================
   MGC · Landing "Cocinita de Madera"
   - Carga diferida del video subido a Shopify (vista previa muda en bucle)
   - Popup de video con sonido, boton de cerrar y boton de silenciar
   - Video externo (YouTube / Vimeo): no carga terceros hasta el clic
   - Barra fija movil con CTA
   - Scroll suave a anclas internas
   Se puede incluir varias veces: la inicializacion es idempotente.
   ========================================================================== */
(function () {
  'use strict';

  if (window.MGCCocinita) {
    window.MGCCocinita.init();
    return;
  }

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------
     Vista previa: carga diferida + play/pausa segun visibilidad
     --------------------------------------------------------------- */
  var videoObserver = null;

  function getVideoObserver() {
    if (videoObserver || !('IntersectionObserver' in window)) return videoObserver;

    videoObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;

          if (entry.isIntersecting) {
            loadVideoSources(video);
            if (video.dataset.mgcAutoplay === 'true' && !reduceMotion) {
              var playing = video.play();
              if (playing && typeof playing.catch === 'function') playing.catch(function () {});
            }
          } else if (!video.paused && video.dataset.mgcAutoplay === 'true') {
            video.pause();
          }
        });
      },
      { rootMargin: '200px 0px', threshold: 0.01 }
    );

    return videoObserver;
  }

  function loadVideoSources(video) {
    if (video.dataset.mgcLoaded === 'true') return;
    video.dataset.mgcLoaded = 'true';

    var sources = video.querySelectorAll('source[data-src]');
    for (var i = 0; i < sources.length; i++) {
      sources[i].setAttribute('src', sources[i].getAttribute('data-src'));
      sources[i].removeAttribute('data-src');
    }
    video.load();
  }

  function initVideos(root) {
    var videos = root.querySelectorAll('video[data-mgc-video]:not([data-mgc-init])');

    for (var i = 0; i < videos.length; i++) {
      var video = videos[i];
      video.setAttribute('data-mgc-init', 'true');

      var observer = getVideoObserver();
      if (observer) {
        observer.observe(video);
      } else {
        loadVideoSources(video);
      }
    }
  }

  /* ---------------------------------------------------------------
     Popup de video
     --------------------------------------------------------------- */
  var lb = null;
  var lastFocused = null;

  var ICON_CLOSE =
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18.3 5.71 12 12l6.3 6.29-1.41 1.42L10.59 13.4 4.3 19.71 2.89 18.3 9.17 12 2.89 5.71 4.3 4.29l6.29 6.3 6.3-6.3z"/></svg>';
  var ICON_SOUND_ON =
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3a4.5 4.5 0 0 0-2.5-4.03v8.05A4.5 4.5 0 0 0 16.5 12zM14 3.23v2.06a7 7 0 0 1 0 13.42v2.06a9 9 0 0 0 0-17.54z"/></svg>';
  var ICON_SOUND_OFF =
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 9v6h4l5 5V4L7 9H3zm18.5-1.09L20.09 6.5 17.5 9.09 14.91 6.5 13.5 7.91 16.09 10.5 13.5 13.09l1.41 1.41 2.59-2.59 2.59 2.59 1.41-1.41-2.59-2.59z"/></svg>';

  function buildLightbox() {
    if (lb) return lb;

    var el = document.createElement('div');
    el.className = 'mgc-lb';
    el.setAttribute('hidden', '');
    el.innerHTML =
      '<div class="mgc-lb__backdrop" data-mgc-lb-close></div>' +
      '<div class="mgc-lb__dialog" role="dialog" aria-modal="true" aria-label="Video">' +
      '<div class="mgc-lb__stage"></div>' +
      '<div class="mgc-lb__bar">' +
      '<button type="button" class="mgc-lb__btn" data-mgc-lb-mute aria-label="Silenciar">' +
      ICON_SOUND_ON +
      '</button>' +
      '<button type="button" class="mgc-lb__btn" data-mgc-lb-close aria-label="Cerrar el video">' +
      ICON_CLOSE +
      '</button>' +
      '</div>' +
      '</div>';

    document.body.appendChild(el);

    lb = {
      root: el,
      dialog: el.querySelector('.mgc-lb__dialog'),
      stage: el.querySelector('.mgc-lb__stage'),
      muteBtn: el.querySelector('[data-mgc-lb-mute]'),
      closeBtn: el.querySelector('[data-mgc-lb-close].mgc-lb__btn'),
      video: null
    };

    el.addEventListener('click', function (event) {
      if (event.target.closest('[data-mgc-lb-close]')) {
        event.preventDefault();
        closeLightbox();
      } else if (event.target.closest('[data-mgc-lb-mute]')) {
        event.preventDefault();
        toggleMute();
      }
    });

    return lb;
  }

  function setMuteUI(muted) {
    if (!lb) return;
    lb.muteBtn.innerHTML = muted ? ICON_SOUND_OFF : ICON_SOUND_ON;
    lb.muteBtn.setAttribute('aria-label', muted ? 'Activar el sonido' : 'Silenciar');
    lb.muteBtn.setAttribute('aria-pressed', muted ? 'true' : 'false');
  }

  function toggleMute() {
    if (!lb || !lb.video) return;
    lb.video.muted = !lb.video.muted;
    setMuteUI(lb.video.muted);
  }

  function openLightbox(trigger) {
    var type = trigger.getAttribute('data-mgc-lb-type');
    var src = trigger.getAttribute('data-mgc-lb-src');
    if (!src) return;

    buildLightbox();
    lastFocused = document.activeElement;

    var ratio = trigger.getAttribute('data-mgc-lb-ratio') || '16 / 9';
    lb.dialog.style.setProperty('--mgc-lb-ratio', ratio);

    lb.stage.innerHTML = '';
    lb.video = null;

    if (type === 'embed') {
      // YouTube / Vimeo: su propio reproductor gestiona el sonido
      var iframe = document.createElement('iframe');
      iframe.setAttribute('src', src);
      iframe.setAttribute('title', trigger.getAttribute('aria-label') || 'Video');
      iframe.setAttribute(
        'allow',
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
      );
      iframe.setAttribute('allowfullscreen', 'true');
      iframe.setAttribute('frameborder', '0');
      lb.stage.appendChild(iframe);
      lb.muteBtn.hidden = true;
    } else {
      var video = document.createElement('video');
      video.setAttribute('playsinline', '');
      video.setAttribute('controls', '');
      video.setAttribute('controlslist', 'nodownload');
      video.setAttribute('autoplay', '');
      var poster = trigger.getAttribute('data-mgc-lb-poster');
      if (poster) video.setAttribute('poster', poster);

      var source = document.createElement('source');
      source.setAttribute('src', src);
      source.setAttribute('type', trigger.getAttribute('data-mgc-lb-mime') || 'video/mp4');
      video.appendChild(source);

      lb.stage.appendChild(video);
      lb.video = video;
      lb.muteBtn.hidden = false;
      setMuteUI(false);

      // Se intenta con sonido; si el navegador lo bloquea, se reproduce en silencio
      var playing = video.play();
      if (playing && typeof playing.catch === 'function') {
        playing.catch(function () {
          video.muted = true;
          setMuteUI(true);
          var retry = video.play();
          if (retry && typeof retry.catch === 'function') retry.catch(function () {});
        });
      }
    }

    lb.root.removeAttribute('hidden');
    document.body.classList.add('mgc-lb-open');
    // fuerza el reflow para que la transicion de entrada se aplique
    void lb.root.offsetWidth;
    lb.root.classList.add('is-open');
    lb.closeBtn.focus();

    document.addEventListener('keydown', onKeydown);
  }

  function closeLightbox() {
    if (!lb || lb.root.hasAttribute('hidden')) return;

    if (lb.video) {
      lb.video.pause();
      lb.video.removeAttribute('src');
    }
    lb.stage.innerHTML = '';
    lb.video = null;

    lb.root.classList.remove('is-open');
    lb.root.setAttribute('hidden', '');
    document.body.classList.remove('mgc-lb-open');
    document.removeEventListener('keydown', onKeydown);

    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    lastFocused = null;
  }

  function onKeydown(event) {
    if (event.key === 'Escape' || event.key === 'Esc') {
      closeLightbox();
      return;
    }
    // Mantiene el foco dentro del popup
    if (event.key === 'Tab' && lb) {
      var focusables = lb.dialog.querySelectorAll(
        'button:not([hidden]), video[controls], iframe, [href], [tabindex]:not([tabindex="-1"])'
      );
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  /* ---------------------------------------------------------------
     Carrusel: si caben todas las tarjetas, se centran y sobran los controles
     --------------------------------------------------------------- */
  function centerSliders() {
    var sliders = document.querySelectorAll('.mgc-slider');

    for (var i = 0; i < sliders.length; i++) {
      var el = sliders[i];
      var sw = el.globalSlide || el.swiper;
      if (!sw || !sw.params) continue;

      var perView = sw.params.slidesPerView;
      if (perView === 'auto') continue;

      var real = el.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length;
      el.classList.toggle('mgc-slider--centered', real <= Math.floor(perView));
    }
  }

  var centerTries = 0;
  function scheduleCentering() {
    centerSliders();
    // slide-section se inicializa en global.js, que puede correr despues que esto
    if (centerTries < 6) {
      centerTries++;
      setTimeout(scheduleCentering, 250);
    }
  }

  var resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(centerSliders, 150);
  });

  /* ---------------------------------------------------------------
     Barra fija movil: aparece al pasar el disparador
     --------------------------------------------------------------- */
  function initSticky(root) {
    var bars = root.querySelectorAll('[data-mgc-sticky]:not([data-mgc-init])');
    if (!bars.length) return;

    for (var i = 0; i < bars.length; i++) {
      var bar = bars[i];
      bar.setAttribute('data-mgc-init', 'true');
      document.body.classList.add('mgc-has-sticky');

      var afterSelector = bar.getAttribute('data-mgc-after');
      var trigger = afterSelector ? document.querySelector(afterSelector) : null;

      if (!trigger || !('IntersectionObserver' in window)) {
        // Sin disparador la barra se queda siempre visible: hay que acomodar
        // igual, o tapa el pie y se encima con los botones de las apps.
        bar.classList.add('is-visible');
        acomodar(bar, true);
        setTimeout(acomodarLuego(bar), 600);
        continue;
      }

      bindSticky(bar, trigger);
    }
  }

  /* La barra fija se monta encima de lo que las apps ya tienen abajo: el
     boton de volver arriba, los cupones, los chats. En vez de perseguir el
     selector de cada app —que cambian sin avisar— se detecta lo que de
     verdad esta fijo y pegado al fondo, y se sube. Los widgets suelen
     inyectarse como hijos directos de <body>, asi que basta con dos niveles. */
  function flotantesDeAbajo(bar) {
    var out = [];
    // Se recorre todo el body: los widgets no siempre cuelgan del primer
    // nivel (el boton de volver arriba de este tema va mucho mas adentro).
    // Se hace una sola vez por aparicion, asi que el costo no se nota.
    var todos = document.body.querySelectorAll('*');
    for (var i = 0; i < todos.length; i++) revisar(todos[i]);
    function revisar(el) {
      if (!el || el === bar || bar.contains(el) || el.contains(bar)) return;
      if (el.hasAttribute('data-mgc-movido')) return;
      var cs;
      try { cs = getComputedStyle(el); } catch (e) { return; }
      if (cs.position !== 'fixed') return;
      var base = parseFloat(cs.bottom);
      if (isNaN(base) || base > 120) return;
      var r = el.getBoundingClientRect();
      if (r.height === 0 || r.height > window.innerHeight * 0.5) return;
      out.push({ el: el, base: base });
    }
    return out;
  }

  function acomodar(bar, visible) {
    var alto = bar.offsetHeight || 0;
    document.body.style.setProperty('--mgc-sticky-h', alto + 'px');
    document.body.classList.toggle('mgc-sticky-on', visible);

    if (visible) {
      flotantesDeAbajo(bar).forEach(function (f) {
        f.el.setAttribute('data-mgc-movido', String(f.base));
        f.el.style.bottom = f.base + alto + 14 + 'px';
      });
    } else {
      var movidos = document.querySelectorAll('[data-mgc-movido]');
      for (var i = 0; i < movidos.length; i++) {
        movidos[i].style.bottom = movidos[i].getAttribute('data-mgc-movido') + 'px';
        movidos[i].removeAttribute('data-mgc-movido');
      }
    }
  }

  function acomodarLuego(bar) {
    return function () { acomodar(bar, true); };
  }

  function bindSticky(bar, trigger) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var visible = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', visible);
          acomodar(bar, visible);
          if (visible) setTimeout(function () { acomodar(bar, true); }, 600);
        });
      },
      { threshold: 0 }
    );
    observer.observe(trigger);
  }

  /* ---------------------------------------------------------------
     Contador de la oferta
     Liquid ya decidio si hay fecha futura; aqui solo se va restando.
     Al llegar a cero el bloque se retira: un 00:00:00 fijo delata
     mas que ayudar.
     --------------------------------------------------------------- */
  function parseEnd(raw) {
    if (!raw) return null;
    var txt = String(raw).trim();
    // "2026-09-30 23:59" -> Safari necesita la T y no admite el espacio
    var m = txt.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?$/);
    var date = m
      ? new Date(+m[1], +m[2] - 1, +m[3], +(m[4] || 23), +(m[5] || 59), +(m[6] || 0))
      : new Date(txt);
    return isNaN(date.getTime()) ? null : date;
  }

  function initCountdowns(root) {
    var nodes = root.querySelectorAll('[data-mgc-countdown]:not([data-mgc-init])');
    if (!nodes.length) return;

    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      node.setAttribute('data-mgc-init', 'true');
      var end = parseEnd(node.getAttribute('data-mgc-countdown'));
      if (!end) {
        node.remove();
        continue;
      }
      bindCountdown(node, end);
    }
  }

  function bindCountdown(node, end) {
    var slots = {
      days: node.querySelector('[data-unit="days"]'),
      hours: node.querySelector('[data-unit="hours"]'),
      minutes: node.querySelector('[data-unit="minutes"]'),
      seconds: node.querySelector('[data-unit="seconds"]')
    };

    function pad(n) {
      return (n < 10 ? '0' : '') + n;
    }

    function tick() {
      var left = end.getTime() - new Date().getTime();
      if (left <= 0) {
        clearInterval(timer);
        var note = node.nextElementSibling;
        if (note && note.classList.contains('mgc-offer__note')) note.remove();
        node.remove();
        return;
      }
      var total = Math.floor(left / 1000);
      if (slots.days) slots.days.textContent = pad(Math.floor(total / 86400));
      if (slots.hours) slots.hours.textContent = pad(Math.floor((total % 86400) / 3600));
      if (slots.minutes) slots.minutes.textContent = pad(Math.floor((total % 3600) / 60));
      if (slots.seconds) slots.seconds.textContent = pad(total % 60);
    }

    tick();
    var timer = setInterval(tick, 1000);
  }

  /* ---------------------------------------------------------------
     Agregar al carrito
     Va por la API Ajax del carrito a proposito. Es la ruta que Shopify
     instrumenta: de ahi sale el evento 'product_added_to_cart', que la app
     oficial de Meta traduce a AddToCart y manda tambien por la API de
     Conversiones. El enlace /cart/<variante>:1 agrega del lado del servidor
     y ese evento no sale, asi que la landing se quedaria sin AddToCart.
     Tras agregar va directo a /checkout (o al carrito si la seccion lo pide).
     AddToCart igual sale, porque el evento lo dispara el alta, no la pagina
     de destino; y en checkout entra InitiateCheckout.
     Si el alta falla, el boton cae al enlace de respaldo y el cliente
     siempre puede comprar.
     --------------------------------------------------------------- */
  function cartRoute(path) {
    var root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + path;
  }

  function addToCart(button) {
    var variantId = button.getAttribute('data-mgc-add');
    if (!variantId || button.hasAttribute('data-mgc-busy')) return;

    var fallback = button.getAttribute('data-mgc-fallback') || cartRoute('cart');
    var label = button.innerHTML;
    button.setAttribute('data-mgc-busy', 'true');
    button.setAttribute('aria-busy', 'true');
    button.innerHTML = button.getAttribute('data-mgc-busy-label') || 'Agregando…';

    fetch(cartRoute('cart/add.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }]
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart/add ' + response.status);
        return response.json();
      })
      .then(function () {
        var dest = button.getAttribute('data-mgc-dest') === 'cart' ? 'cart' : 'checkout';
        window.location.href = cartRoute(dest);
      })
      .catch(function () {
        button.removeAttribute('data-mgc-busy');
        button.removeAttribute('aria-busy');
        button.innerHTML = label;
        window.location.href = fallback;
      });
  }

  /* ---------------------------------------------------------------
     Clics globales
     --------------------------------------------------------------- */
  function onDocumentClick(event) {
    if (!event.target.closest) return;

    var adder = event.target.closest('[data-mgc-add]');
    if (adder) {
      event.preventDefault();
      addToCart(adder);
      return;
    }

    var opener = event.target.closest('[data-mgc-lightbox]');
    if (opener) {
      event.preventDefault();
      openLightbox(opener);
      return;
    }

    var link = event.target.closest('.mgc-cc a[href^="#"]');
    if (!link) return;

    var id = link.getAttribute('href');
    if (!id || id === '#') return;

    var target = document.querySelector(id);
    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    if (history.replaceState) history.replaceState(null, '', id);
  }

  /* ---------------------------------------------------------------
     Init
     --------------------------------------------------------------- */
  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    initVideos(scope);
    initCountdowns(scope);
    initSticky(document);
    centerTries = 0;
    scheduleCentering();
  }

  window.MGCCocinita = { init: init, open: openLightbox, close: closeLightbox };

  document.addEventListener('click', onDocumentClick);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  /* Editor de temas de Shopify */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
  document.addEventListener('shopify:section:unload', function () {
    closeLightbox();
    if (!document.querySelector('[data-mgc-sticky]')) {
      document.body.classList.remove('mgc-has-sticky');
    }
  });
})();
